/**
 * WalletCallbackPage - Handles OAuth callback from wallet authorization
 *
 * This page receives the wallet access token and posts it back to the opener window.
 */

import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const _WALLET_APP_URL = process.env.REACT_APP_WALLET_APP_URL || "https://wallet.thingdom.ai";

function WalletCallbackPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    const error = searchParams.get("error");

    if (window.opener) {
      if (token) {
        // Success - post token back to opener
        window.opener.postMessage(
          { type: "WALLET_CONNECTED", accessToken: token },
          window.location.origin
        );
      } else if (error) {
        // Error - notify opener
        window.opener.postMessage(
          { type: "WALLET_ERROR", error },
          window.location.origin
        );
      } else {
        // Cancelled
        window.opener.postMessage(
          { type: "WALLET_CANCELLED" },
          window.location.origin
        );
      }
    }

    // Close the popup after a short delay
    setTimeout(() => {
      window.close();
    }, 500);
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-penta-grey-light">
      <div className="text-center">
        <div className="animate-spin h-8 w-8 border-2 border-penta-blue rounded-full border-t-transparent mx-auto mb-4"></div>
        <p className="text-penta-black">Completing wallet connection...</p>
      </div>
    </div>
  );
}

export default WalletCallbackPage;
